if (!customElements.get('b2b-photo-carousel')) {
  customElements.define('b2b-photo-carousel', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (!this.isConnected || this.cleanup) return;
      const track = this.querySelector('.b2b-carousel__track');
      const controls = this.querySelector('.b2b-carousel__controls');
      if (!track || !controls || !controls.querySelector('[data-carousel-next]')) {
        this.frame = requestAnimationFrame(() => this.initialize()); return;
      }
      const allSlides = Array.from(track.children);
      let slides = allSlides.filter(slide => !slide.hidden);
      const prev = controls.querySelector('[data-carousel-prev]');
      const next = controls.querySelector('[data-carousel-next]');
      const dots = Array.from(controls.querySelectorAll('[data-carousel-dot]'));
      const status = controls.querySelector('[data-carousel-status]');
      let index = 0;
      const update = () => {
        slides = allSlides.filter(slide => !slide.hidden);
        controls.hidden = slides.length < 2;
        index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / (track.clientWidth || 1))));
        prev.disabled = index === 0;
        next.disabled = index === slides.length - 1;
        dots.forEach((dot, i) => { dot.hidden = allSlides[i]?.hidden || false; dot.setAttribute('aria-pressed', String(allSlides[i] === slides[index])); });
        slides.forEach((slide, i) => { slide.inert = i !== index; slide.setAttribute('aria-hidden', String(i !== index)); });
        status.textContent = `${index + 1} / ${slides.length}`;
      };
      const go = (i) => {
        const target = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({left: target * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      const click = (e) => {
        const button = e.target.closest('button');
        if (!button || !controls.contains(button)) return;
        if (button === prev) go(index - 1);
        else if (button === next) go(index + 1);
        else if (button.hasAttribute('data-carousel-dot')) go(Number(button.dataset.carouselDot));
      };
      const key = (e) => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault(); go(index + (e.key === 'ArrowRight' ? 1 : -1));
      };
      let width = track.clientWidth;
      const observer = new ResizeObserver(() => {
        if (track.clientWidth !== width) { width = track.clientWidth; track.scrollTo({left: index * width, behavior: 'instant'}); }
      });
      track.addEventListener('scroll', update, {passive: true});
      controls.addEventListener('click', click);
      this.addEventListener('keydown', key);
      observer.observe(track);
      const visibilityObserver = new MutationObserver(update);
      visibilityObserver.observe(track, {subtree:true, attributes:true, attributeFilter:['hidden']});
      controls.hidden = false; update();
      this.cleanup = () => { visibilityObserver.disconnect(); observer.disconnect(); track.removeEventListener('scroll', update); controls.removeEventListener('click', click); this.removeEventListener('keydown', key); };
    }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.cleanup?.(); this.cleanup = null; }
  });
}
